import { render } from "./layerUpdateTime.vue?vue&type=template&id=0b55e4d9"
import script from "./layerUpdateTime.vue?vue&type=script&lang=js"
export * from "./layerUpdateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__